import { setClassName } from '@change-corgi/core/error';

export class LocalSectionDataMissingError extends Error {
	constructor() {
		super('No data returned from local section homepage query');
	}
}
setClassName(LocalSectionDataMissingError, 'LocalSectionDataMissingError');
